import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useEffect, useState } from 'react';
import './pageSlider.css';
function PageSlider({ children }) {
    const pageSliderRef = useRef(null);
    const lastEventTime = useRef(0);
    const isMouseDown = useRef(false);
    const debounceTime = 300;
    const canGenerateDrops = useRef(true);
    const childrenArray = Array.isArray(children) ? children : [children];
    const totalPages = childrenArray.length;
    const [currentPage, setCurrentPage] = useState(0);
    const [prevPageIndex, setPrevPageIndex] = useState(null);
    const [direction, setDirection] = useState(null);
    const [isAnimating, setIsAnimating] = useState(false);
    const nextPage = () => {
        if (currentPage < totalPages - 1 && !isAnimating) {
            setDirection('left');
            setPrevPageIndex(currentPage);
            setIsAnimating(true);
            setCurrentPage((prev) => prev + 1);
        }
    };
    const prevPage = () => {
        if (currentPage > 0 && !isAnimating) {
            setDirection('right');
            setPrevPageIndex(currentPage);
            setIsAnimating(true);
            setCurrentPage((prev) => prev - 1);
        }
    };
    useEffect(() => {
        if (isAnimating) {
            setPrevPageIndex(null);
            const timeout = setTimeout(() => {
                setDirection(null);
                setIsAnimating(false);
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [isAnimating]);
    useEffect(() => {
        const pageSlider = pageSliderRef.current;
        if (!pageSlider)
            return;
        const mouseClicked = (event) => {
            isMouseDown.current = event.type === 'mousedown';
        };
        const handleClick = (event) => {
            const currentTime = Date.now();
            if (currentTime - lastEventTime.current < debounceTime)
                return;
            if (isMouseDown.current && canGenerateDrops.current) {
                canGenerateDrops.current = false;
                const rect = pageSlider.getBoundingClientRect();
                const x = event.clientX - rect.left;
                const y = event.clientY - rect.top;
                for (let i = 0; i < 20; i++) {
                    const drop = document.createElement('div');
                    drop.classList.add('waterDrop');
                    const startX = x + (Math.random() - 0.5) * 100;
                    const startY = y + (Math.random() - 0.5) * 100;
                    drop.style.left = `${startX}px`;
                    drop.style.top = `${startY}px`;
                    drop.style.position = 'absolute';
                    pageSlider.appendChild(drop);
                    let velocityY = -10;
                    const gravity = 0.5;
                    const floor = rect.height;
                    let velocityX = (Math.random() - 0.5) * 4;
                    const animateDrop = () => {
                        velocityY += gravity;
                        const currentY = parseFloat(drop.style.top) + velocityY;
                        const currentX = parseFloat(drop.style.left) + velocityX;
                        if (currentY >= floor) {
                            drop.remove();
                        }
                        else {
                            drop.style.position = 'fixed';
                            drop.style.left = `${currentX}px`;
                            drop.style.top = `${currentY}px`;
                            velocityX += (Math.random() - 0.5) * 0.2;
                            requestAnimationFrame(animateDrop);
                        }
                    };
                    requestAnimationFrame(animateDrop);
                }
                lastEventTime.current = currentTime;
                setTimeout(() => {
                    canGenerateDrops.current = true;
                }, debounceTime);
            }
        };
        pageSlider.addEventListener('mousedown', mouseClicked);
        pageSlider.addEventListener('mouseup', mouseClicked);
        pageSlider.addEventListener('mousedown', handleClick);
        return () => {
            pageSlider.removeEventListener('mousedown', mouseClicked);
            pageSlider.removeEventListener('mouseup', mouseClicked);
            pageSlider.removeEventListener('mousedown', handleClick);
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "pageSlider", ref: pageSliderRef, children: [_jsx("div", { className: "waterButton", onClick: prevPage, children: '<' }), _jsx("div", { className: "waterButton", onClick: nextPage, children: '>' })] }), _jsxs("div", { className: "sliderContentWrapper", children: [prevPageIndex !== null && (_jsx("div", { className: `sliderPage${direction ? ` animate-out-${direction}` : ''}`, children: childrenArray[prevPageIndex] })), _jsx("div", { className: `sliderPage${direction ? ` animate-in-${direction}` : ''}`, children: childrenArray[currentPage] })] })] }));
}
export default PageSlider;
